export default {
  ACCESS_TYPE_NONE_ID: 'ACCESS_TYPE_NONE_ID',
};
